import React from 'react';
import { Box, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { capitalizeFirstLetter } from '@europrocurement/l2d-utils';
import type {
    DocumentColor,
    DocumentIconType,
} from '@europrocurement/l2d-modules/modules/Dossiers/hooks';
import DocumentIcon from '../../DocumentIcon/DocumentIcon';

export type DossierDocumentsValidationDocumentNameProps = {
    fileIcon: DocumentIconType;
    documentColor?: DocumentColor;
    label: string;
    fileName?: string;
};

const DossierDocumentsValidationDocumentName: React.FunctionComponent<DossierDocumentsValidationDocumentNameProps> =
    function (props) {
        const { documentColor, fileIcon, fileName, label } = props;
        const { palette, breakpoints } = useTheme();
        const downMd = useMediaQuery(breakpoints.down('md'));

        return (
            <Box sx={{ display: 'flex' }}>
                <Box
                    sx={{
                        display: 'flex',
                        gap: '0 14px',
                        alignItems: 'center',
                        marginLeft: '20px',
                        paddingLeft: '32px',
                        borderLeftColor: palette.grey[200],
                        borderLeftWidth: '1px',
                        borderLeftStyle: 'solid',
                    }}
                >
                    <DocumentIcon
                        icon={fileIcon}
                        color={documentColor}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        {label && (
                            <Tooltip
                                title={label}
                                arrow
                                placement="top"
                            >
                                <Typography
                                    sx={{
                                        color: palette.primary.dark,
                                    }}
                                    variant="l2dbodys"
                                >
                                    {capitalizeFirstLetter(
                                        label.length > 30
                                            ? `${label.substring(0, 27)}[...]`
                                            : label,
                                    )}
                                </Typography>
                            </Tooltip>
                        )}
                        {fileName && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: downMd ? 'column' : 'row',
                                    alignItems: downMd ? 'flex-start' : 'center',
                                    gap: downMd ? '4px 0' : '0 4px',
                                }}
                            >
                                <Tooltip
                                    title={fileName}
                                    arrow
                                    placement="top"
                                >
                                    <Typography
                                        component="span"
                                        sx={{ color: 'text.gris70' }}
                                        variant="l2dbodyxs"
                                    >
                                        {fileName.length > 18
                                            ? `${fileName.substring(0, 18)}[...]`
                                            : fileName}
                                    </Typography>
                                </Tooltip>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        );
    };

export default DossierDocumentsValidationDocumentName;
